var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-quantity"},[_c('label',[_vm._v(_vm._s(_vm.$t('trade.quantity')))]),_vm._v(" "),_c('PlusMinusInput',{attrs:{"step":_vm.step,"value":_vm.value,"min":_vm.step},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }